(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["teacher-testimonial-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('oy-testimonial-video')) return;
  const players = new Map();
  let activePlayer = null;
  let sequence = 0;

  class TestimonialVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        players.set(this.playerId, this);
        return;
      }
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.trigger = this.querySelector('[data-testimonial-open]');
      if (!this.dialog || !this.video || !this.trigger) return;
      this.initialized = true;
      this.playerId = `oy-testimonial-${++sequence}`;
      players.set(this.playerId, this);
      this.backgroundVideos = [];
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('[data-testimonial-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.afterClose());
      this.dialog.addEventListener('pointerdown', event => {
        this.backdropPointer = this.isBackdrop(event);
      });
      this.dialog.addEventListener('click', event => {
        if (this.backdropPointer && this.isBackdrop(event)) this.dialog.close();
        this.backdropPointer = false;
      });
    }

    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const bounds = this.dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    }

    open(addHistory = true) {
      if (this.dialog.open) return;
      if (activePlayer) activePlayer.dialog.close();
      this.backgroundVideos = Array.from(document.querySelectorAll('video')).filter(video => video !== this.video && !video.paused);
      this.backgroundVideos.forEach(video => video.pause());
      this.dialog.showModal();
      activePlayer = this;
      document.documentElement.classList.add('oy-testimonial-open');
      if (addHistory) {
        try {
          history.pushState({...history.state, oyTestimonialVideo: this.playerId}, '', location.href);
        } catch (error) {}
      }
      this.video.src = this.video.dataset.src;
      this.video.muted = false;
      this.video.play().catch(() => {});
    }

    afterClose() {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      if (activePlayer === this) {
        activePlayer = null;
        document.documentElement.classList.remove('oy-testimonial-open');
        this.trigger.focus({preventScroll: true});
      }
      if (history.state?.oyTestimonialVideo === this.playerId) history.back();
      if (!activePlayer && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.backgroundVideos.forEach(video => {
          const bounds = video.getBoundingClientRect();
          if (video.isConnected && video.muted && bounds.bottom > 0 && bounds.top < innerHeight && bounds.right > 0 && bounds.left < innerWidth) video.play().catch(() => {});
        });
      }
      this.backgroundVideos = [];
    }

    disconnectedCallback() {
      players.delete(this.playerId);
      if (this.dialog?.open) this.dialog.close();
    }
  }

  window.addEventListener('popstate', () => {
    const target = players.get(history.state?.oyTestimonialVideo);
    if (activePlayer && activePlayer !== target) activePlayer.dialog.close();
    if (target) target.open(false);
  });
  document.addEventListener('play', event => {
    if (activePlayer && event.target instanceof HTMLVideoElement && event.target !== activePlayer.video) event.target.pause();
  }, true);
  customElements.define('oy-testimonial-video', TestimonialVideo);
})();
  } catch(e) { console.error(e); }
})();

})();
